<nav id="sidenav-content" class="navbar navbar-expand-lg navbar-light ">
  <div class="container">
    <div class="container-fluid">
      <span class="nav-link" (click)="onScrollToHeader()">{{ 'footer.backToTop' | t }}</span>
      @if (!mobile) {
        <span href="#">
          <div class="branding">
            <app-brand-mark [size]="40"></app-brand-mark>
          </div>
        </span>
      }
      @if (visibleSidebar4 === false) {
        <span class="nav-link" (click)="onScrollToFooter()">{{ 'footer.showFooter' | t }}</span>
      }
      @if (visibleSidebar4) {
        <span class="nav-link" (click)="onHideToFooter()">{{ 'footer.hideFooter' | t }}</span>
      }
    </div>
  </div>
</nav>


<!-- <p-sidebar [(visible)]="visibleSidebar4" styleClass="p-sidebar-lg" position="bottom" [baseZIndex]="0" [autoZIndex]="false" [modal]="true">
<app-footer (click)="visibleSidebar4 = false" app-footer></app-footer>
</p-sidebar> -->

@if (visibleSidebar4) {
  <mat-nav-list>
    <!-- <app-footer (click)="visibleSidebar4 = false"></app-footer> -->
    <app-footer></app-footer>
  </mat-nav-list>
}
